/* global window */
import { Action } from '../actions/auth';

export const LoginStatus = {
  LoggedOut: 0,
  InProgress: 1,
  Failed: 2,
  LoggedIn: 3,
  AccountNotFound: 4,
  EmailMismatch: 5,
  AccountNotLinked: 6,
};

const defaultState = {
  status: LoginStatus.LoggedOut,
};

// NOTE: @gasbuddy/web populates initial state for auth
// Reference: https://github.com/gas-buddy/web/blob/2ad0b515b92d436e10c5e3e8d4e04afcf22f0aa4/src/renderUtils.js#L48
export default function authReducer(state = defaultState, action) {
  const { status } = state;
  const body = action?.payload;

  switch (action?.type) {
    case Action.Auth.LoginIfVerifiedCompleted: {
      const responseErrorCode = body?.code;
      return {
        ...state,
        status: LoginStatus[responseErrorCode] || LoginStatus.LoggedIn,
        response: body,
      };
    }

    case Action.Auth.LoginIfVerifiedFailed: {
      const responseErrorCode = body?.response?.code;
      return {
        ...state,
        status: LoginStatus[responseErrorCode] || LoginStatus.AccountNotFound,
        oneTapError: {
          email: body?.response?.socialEmail,
          status: body?.response?.statusCode,
          message: body?.response?.message,
        },
      };
    }


    case Action.Auth.LoginIfVerifiedPending:
      return {
        ...state,
        status: LoginStatus.InProgress,
      };

    case Action.Auth.LoginCompleted:
      if (status !== LoginStatus.LoggedIn) {
        return {
          status: LoginStatus.LoggedIn,
          as: body.identifier,
          groups: body.groups,
        };
      }
      break;

    case Action.Auth.LoginFailed:
      if (status !== LoginStatus.Failed || state.error !== body.error) {
        return {
          status: LoginStatus.Failed,
          error: body.error.message,
        };
      }
      break;

    case Action.Auth.LoginPending:
      if (state.status !== LoginStatus.InProgress) {
        return { status: LoginStatus.InProgress };
      }
      break;

    case Action.Auth.LoggedOut:
      if (state.status !== LoginStatus.LoggedOut) {
        if (window) {
          window.location = '/';
        }
        // Otherwise we're server side, what to do?
        return { status: LoginStatus.LoggedOut };
      }
      break;

    default:
      break;
  }

  return state;
}
